import axios from 'axios';

import http from '@/services/http.js';
import { getJianyingAudioContentType } from '../utils/jianyingAudioUpload.js';

const JIANYING_API = '/videoapi/jianying';

export const uploadJianyingJobAudio = async ({
  clientId,
  file,
  slotId,
  templateId,
  durationUs,
}) => {
  const contentType = getJianyingAudioContentType(file);
  const signingResponse = await http.post(`${JIANYING_API}/jobs/audio/upload-url`, {
    client_id: clientId,
    jianying_template_id: templateId,
    slot_id: slotId,
    file_name: file.name,
    content_type: contentType,
    file_size: file.size,
    duration_us: durationUs,
  });
  const signed = signingResponse.data.data;
  await axios.put(signed.uploadUrl || signed.upload_url, file, {
    headers: signed.headers,
  });
  return {
    kind: 'audio',
    object_key: signed.object_key,
    file_name: file.name,
    duration_us: durationUs,
  };
};

export const cleanupJianyingJobAudio = async ({
  clientId,
  objectKeys,
}) => {
  const keys = [...new Set(objectKeys || [])].filter(Boolean);
  if (!clientId || keys.length === 0) return { deleted: [], retained: [] };
  const response = await http.post(`${JIANYING_API}/jobs/audio/cleanup`, {
    client_id: clientId,
    object_keys: keys,
  });
  return response.data.data;
};
